module.exports = "https://static.moomoo.com/components/common-redpacket/images/title.fdc1dd46b3.png";